import subscriptionCreatedAlertDictionary from '@widgets/subscription-created-alert/i18n/ru/subscription-created-alert.dic.json';

export const subscriptionCreatedAlert = {
  SUBSCRIPTION_CREATED_ALERT: subscriptionCreatedAlertDictionary,
};

export const subscriptionCreatedAlertNamespaces = [
  'SUBSCRIPTION_CREATED_ALERT',
];
